import React, { useEffect } from "react";
import { produce } from "immer";
import { makeStyles } from "@material-ui/core/styles";
import { BiEdit } from "react-icons/bi";
import Selects from "react-select";
import Switch from "@material-ui/core/Switch";
import Badge from "components/Badge/Badge.js";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import Tooltip from "@material-ui/core/Tooltip";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import style from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import { localApi, credentials } from "utils/imgApi";
import styRadio from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import styHoever from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyless = makeStyles(styRadio);
const useStyleSweet = makeStyles(styleSweet);
const useHoever = makeStyles(styHoever);

export default function ClientUpdateDate(props) {
    const [items, setItems] = React.useState([]);
    const [addressList, setAddressList] = React.useState([]);
    const [checkOldAddress, setCheckOldAddress] = React.useState(false);
    const [checkedFullSize, setCheckedFullSize] = React.useState(false);
    const [simpleSelect, setSimpleSelect] = React.useState("");
    const [simpleSelectErr, setSimpleSelectErr] = React.useState("");
    const [cartId, setCartId] = React.useState();
    const [clientid, setClientid] = React.useState("");
    const [btn, setBtn] = React.useState(false);

    const [daysLeft, setDaysLeft] = React.useState(null);
    const [daysOver, setDaysOver] = React.useState(null);

    const [alertType, alertTypeOps] = React.useState("");
    const [alertMsg, alertMsgOps] = React.useState("");
    const [submitted, setSubmitted] = React.useState(false);

    const [submitteds, setSubmitteds] = React.useState(false);
    const [submittedConfirm, setSubmittedConfirm] = React.useState(false);

    const classes = useStyles();
    const classe = useStyle();
    const classesRadio = useStyless();
    const classSweet = useStyleSweet();
    const classeHover = useHoever();

    const adminObj = JSON.parse(sessionStorage.getItem("sessionData"));

    async function getUser() {
        const api =
            localApi + `/clientGroup/list/byAdminId/${adminObj && adminObj.id}`;
        const results = await fetch(api, {
            method: "GET",
            headers: {
                Authorization: `Basic ${credentials}`,
            },
        });
        const getResults = await results.json();
        setItems(getResults && getResults.filter((f) => f.type != "Crm"));
        // console.log(getResults.user);
    }

    useEffect(() => {
        getUser();
    }, []);

    const handleBoots = async (simpleSelect) => {
        if (simpleSelect.value) {
            let newSpli = simpleSelect.value.split("-");
            const ids = items.find((f) => f.mobile === newSpli[1]);
            // console.log(ids);
            const api = localApi + `/register/byMobile/${ids.mobile}`;
            const result = await fetch(api, {
                method: "GET",
                headers: {
                    Authorization: `Basic ${credentials}`,
                },
            });
            const getResult = await result.json();
            // console.log(getResult);
            setClientid(getResult && getResult);

            const endDate = new Date(getResult.endDate);
            const now = new Date();

            if (isNaN(endDate.getTime())) {
                console.error("Invalid end date");
                return;
            }

            // Calculate time difference
            const diffTime = endDate.getTime() - now.getTime();

            // Calculate days (rounding down to full days)
            const diffDays = Math.floor(Math.abs(diffTime) / (1000 * 60 * 60 * 24));

            if (diffTime > 0) {
                setDaysLeft(diffDays);
                setDaysOver(null);
            } else {
                setDaysLeft(null);
                setDaysOver(diffDays);
            }

        }
        setSimpleSelect(simpleSelect);
    };

    const select = {
        width: "100%",
        maxWidth: 600,
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            padding: 10,
        }),
        menu: (state) => ({
            color: "#d81b60",
        }),
        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = "opacity 300ms";

            return { ...provided, opacity, transition };
        },
    };

    const SubmitUpdateDate = async () => {
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Basic ${credentials}`,
            }
        };

        fetch(
            localApi +
            `/register/updateEndDate/byId/${clientid.id}`,
            requestOptions
        )
            .then((response) => response.json())
            .then((data) => {
                // console.log(data);
                if (data.message === "Data Updated Successfully !!!") {
                    alertTypeOps("success");
                    alertMsgOps("Client Renewal Package Succesfully");
                    setSubmitted(true);
                }
            });
    }

    const hideAlert = () => {
        setSubmitted(false);
        window.location.reload(false);
    };

    const hideAlerts = () => {
        setSubmitteds(false);
        setSubmittedConfirm(false);
        window.location.reload(false);
    };

    const endDate = new Date(clientid.endDate);
    const currentDate = new Date();
    const showButton = currentDate > endDate;


    return (
        <div>
            <GridContainer justify="center" alignItems="center">
                <GridItem xs={12} sm={12} md={8}>
                    <Card>
                        <CardHeader color="rose" icon>
                            <CardIcon color="rose">
                                <BiEdit />
                            </CardIcon>
                            <h3 className={classes.cardIconTitle}>
                                <small>Select client</small>
                            </h3>
                        </CardHeader>
                        <CardBody>
                            <GridContainer justify="center" alignItems="center">
                                <GridItem xs={12} sm={8} md={8}>
                                    <label className={classe.selectLabel}>Select Company & Client Name</label>
                                    <Selects
                                        styles={customStyles}
                                        style={select}
                                        required={true}
                                        placeholder="Select Company & Client Name..."
                                        value={simpleSelect}
                                        name="simpleSelect"
                                        onChange={handleBoots}
                                        options={
                                            items &&
                                            items.map((c) => {
                                                return {
                                                    label:
                                                        c && c.company ? c.company + "-" + c.mobile : c.firstname + " " + c.lastname + "-" + c.mobile,
                                                    value:
                                                        c && c.company ? c.company + "-" + c.mobile : c.firstname + " " + c.lastname + "-" + c.mobile,
                                                };
                                            })
                                        }
                                    />
                                    <span style={{ color: "red" }}>{simpleSelectErr}</span>
                                </GridItem>{" "}
                            </GridContainer>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridContainer justify="center" alignItems="center">
                    {submitted ? (
                        <SweetAlert
                            type={alertType}
                            style={{ display: "block", marginTop: "-100px" }}
                            title={alertMsg}
                            onConfirm={() => hideAlert()}
                            confirmBtnCssClass={classSweet.button + " " + classSweet.success}
                        />
                    ) : null}
                    {simpleSelect ?
                        <GridItem xs={12} sm={12} md={5}>
                            <Card>
                                <CardBody>
                                    <h4 style={{ textAlign: "center", fontWeight: "bold" }}>Client Renewal Package</h4>
                                    <p className={classes.cardDescription}>
                                        <span style={{ fontWeight: "bold" }}>
                                            {clientid && clientid.company
                                                ? clientid.company
                                                : clientid.firstname + " " + clientid.lastname}</span>
                                    </p>
                                    <p className={classes.cardDescription}>
                                        {clientid.firstname + " " + clientid.lastname}
                                        <br />
                                        {clientid.city + ", " + clientid.state + ", " + clientid.country}<br />
                                        <span style={{ color: "green" }}>{"Create Date" + " - " + clientid.createDate.split('T')[0]}</span><br />
                                        <span style={{ color: "red" }}>{"End Date" + " - " + clientid.endDate.split('T')[0]}</span>

                                    </p>
                                    {daysLeft !== null && <p style={{ color: "green" }}>✅ Days left: {daysLeft + " days"}</p>}
                                    {daysOver !== null && <p style={{ color: "red" }}>⚠️ Days passed: {daysOver + " days"}</p>}
                                    {showButton && (
                                        <Button
                                            color="rose"
                                            onClick={SubmitUpdateDate}
                                            className={classes.updateProfileButton}
                                        >
                                            Update
                                        </Button>)}
                                </CardBody>

                            </Card>

                        </GridItem>
                        : ""}
                </GridContainer>
            </GridContainer>
        </div>
    );
}
